import React, { useState, useEffect } from "react";

const FillInTheBlanksDraggableReadingAndWriting = ({
  sentence,
  options,
  onOptionChange,
  isSubmitted,
}) => {
  const parts = sentence.split(/(__add_blank__|<span[^>]*>.*?<\/span>)/);
  const placeholderIndices = parts
    .map((part, index) => (part.startsWith("<span") ? index : null))
    .filter((index) => index !== null);
  const initialReplacedOptions = Array(placeholderIndices.length).fill("");
  const [replacedOptions, setReplacedOptions] = useState(initialReplacedOptions);

  const handleDropdownChange = (event, index) => {
    const option = event.target.value;
    replacePlaceholder(index, option);
  };

  const replacePlaceholder = (index, option) => {
    const newReplacedOptions = [...replacedOptions];
    newReplacedOptions[index] = option;
    setReplacedOptions(newReplacedOptions);
    onOptionChange(newReplacedOptions);
  };

  useEffect(() => {
    setReplacedOptions(initialReplacedOptions);
  }, [sentence]);

  useEffect(() => {
    if (!isSubmitted) {
      setReplacedOptions(initialReplacedOptions);
    }
  }, [isSubmitted]);

  const getCorrectAnswer = (index) => {
    const spanPart = parts[placeholderIndices[index]];
    const correctAnswer = spanPart.match(/<span[^>]*>(.*?)<\/span>/)[1];
    return correctAnswer.trim();
  };

  const isCorrectAnswer = (placeholderIndex) => {
    const correctAnswer = getCorrectAnswer(placeholderIndex);
    return replacedOptions[placeholderIndex] === correctAnswer;
  };

  const isIncorrectOption = (placeholderIndex) => {
    const selectedOption = replacedOptions[placeholderIndex];
    return selectedOption === "" || !isCorrectAnswer(placeholderIndex);
  };

  return (
    <section className="rounded-md border border-slate-200 bg-white p-4 shadow-sm sm:p-5">
      <div className="mb-4">
        <p className="text-sm font-semibold uppercase text-purple-700">
          Passage
        </p>
        <h2 className="mt-1 text-lg font-extrabold text-gray-900">
          Select the best option for each blank
        </h2>
      </div>

      <div className="rounded-md bg-slate-50 p-4 text-sm leading-8 text-gray-700 ring-1 ring-slate-100 sm:text-base">
        {parts.map((part, index) => {
          if (part.startsWith("<span") && part.endsWith("</span>")) {
            const placeholderIndex = placeholderIndices.indexOf(index);

            return (
              <select
                key={index}
                onChange={(event) =>
                  handleDropdownChange(event, placeholderIndex)
                }
                value={replacedOptions[placeholderIndex]}
                className={`mx-1 inline-flex min-h-10 min-w-32 cursor-pointer rounded-md border px-3 py-2 text-sm font-bold shadow-sm outline-none transition focus:border-purple-400 focus:ring-2 focus:ring-purple-100 ${
                  isSubmitted
                    ? isCorrectAnswer(placeholderIndex)
                      ? "border-green-200 bg-green-50 text-green-700"
                      : isIncorrectOption(placeholderIndex)
                      ? "border-red-200 bg-red-50 text-red-700"
                      : ""
                    : "border-purple-200 bg-white text-purple-800"
                }`}
                disabled={isSubmitted}
              >
                <option value="">Select...</option>
                {options[placeholderIndex]
                  .split(", ")
                  .map((option, optionIndex) => (
                    <option key={optionIndex} value={option.trim()}>
                      {option.trim()}
                    </option>
                  ))}
              </select>
            );
          } else if (!part.includes("__add_blank__")) {
            return <span key={index}>{part}</span>;
          } else {
            return null;
          }
        })}
      </div>
    </section>
  );
};

export default FillInTheBlanksDraggableReadingAndWriting;
